import React from 'react'

export default function GcStats() {
    return (
        <div>
            THis is gc stats part of quick info
        </div>
    )
}
